/**
* Created by elmer on 30/05/17.
*/
<style>
  .dashboard-card {
    border-radius: 4px;
    box-shadow: 0 2px 7px rgba(0,0,0,.15);
    background-color: white;
    width: 100%;
    height: 200px;
  }

  .dashboard-card a {
    color: #aaa;
  }

  .dashboard-card > a:hover > .dashboard-header {
    background: #5cadff;
    border-bottom: 1px solid #5cadff;
  }

  .dashboard-card > a:hover > .dashboard-body > .dashboard-card-title-wrapper::after {
    border: 1px solid #5cadff;
  }

  .dashboard-header {
    display: -webkit-flex;
    -webkit-align-items: center;
    -webkit-justify-content: center;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 150px;
    background: #eef1f7;
    border-bottom: 1px solid #dadfea;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .dashboard-header > img {
    width: 100px;
    height: 100px;
  }

  .dashboard-body {
    padding: 15px;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
  }

  .dashboard-card-title-wrapper {
    position: relative;
  }

  .dashboard-card-title-wrapper::after {
    content: " ";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 25px;
    border: 1px solid #dadfea;
  }

  .dashboard-card-title {
    font-size: 17px;
    font-weight: 500;
    margin-bottom: 20px;
  }
</style>
<template>
  <div class="dashboard-card">
    <a @click="navigate">
      <div class="dashboard-header" v-if="icon">
        <img :src="icon" />
      </div>
      <div class="dashboard-body">
        <slot name="title">
          <div class="dashboard-card-title-wrapper">
            <p class="dashboard-card-title">{{ title }}</p>
          </div>
        </slot>
        <slot name="description">
          <p class="mt20 fs14">{{ description }}</p>
        </slot>
      </div>
    </a>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true,
      },
      description: {
        type: String,
        required: true,
      },
      icon: {
        type: String,
      },
      route: {
        type: String,
      },
    },
    methods: {
      navigate() {
        this.$emit('click');
        if (this.route) {
          this.$router.push({
            path: this.route,
          });
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// DashboardCard.vue?53e4ef38